import { render } from "./FAB.vue?vue&type=template&id=9a967b08"
import script from "./FAB.vue?vue&type=script&lang=js"
export * from "./FAB.vue?vue&type=script&lang=js"

import exportComponent from "C:\\job\\ems-ISO-final\\frontend_ems\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__